import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

function InfoGeneraliPerUtente(props) {

    const [infoGenerali,setInfoGenerali] = useState({patente:"",automunito:"",corso:"", corsoVicinato: ""})
    const getAssistente = useSelector(state => state.wizardReducer)

    useEffect(() => {
        if (getAssistente && getAssistente.infoGenerali) {
            setInfoGenerali(getAssistente.infoGenerali)
        }
    }, [])
    return (
        <div>
            <span style={{fontWeight:"bold",fontSize:"20px"}}>Patente: </span><span>{infoGenerali.patente === "1"?"SI":"NO"}</span>
            <br/>
            <span style={{fontWeight:"bold",fontSize:"20px"}}>Automunito/a: </span><span>{infoGenerali.automunito === "1"?"SI":"NO"}</span>
            <br/>
            <span style={{fontWeight:"bold",fontSize:"20px"}}>Corsi di formazione: </span><span>{infoGenerali.corso === "1"?"SI":"NO"}</span>
            <br/>
            <span style={{fontWeight:"bold",fontSize:"20px"}}>Corsi di formazione come assistente familiare di vicinato: </span><span>{infoGenerali.corsoVicinato === "1"?"SI":"NO"}</span>
        </div>

    )


}

export default InfoGeneraliPerUtente